import React from "react";
import { withStyles } from '@material-ui/core';

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
    },
});

class OrgHome extends React.Component {
    render(){
        return (<div>OrgHome</div>);
    }
}

export default (withStyles(styles)(OrgHome));